import React from 'react'
import supabase from '../../helper/supabaseClient';
import { useEffect, useState } from 'react'
import { useUserProfile } from '../../helper/UserProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../../stylesheets/profile.scss';
import MobileProfile from '../mobile/MobileProfile';

function RevalidationProfile({}) {
  
    const [tier, setTier] = useState("");
    const [renewalDate, setRenewalDate] = useState("");
    const [appDate, setAppDate] = useState("");
    const [lastRenewal, setLastRenewal] = useState("");
    const [nmcPin, setNmcPin] = useState("");
    const [error, setError] = useState("");
    const [id, setId] = useState("");
    const [success, setSuccess] = useState("");
    const [allQualifications, setAllQualifications] = useState([]);
    const [selectedQualifications, setSelectedQualifications] = useState([]);


    const {profile, setProfile, loading } = useUserProfile();

    const handleSubmit = async (e) => {
    e.preventDefault();

      if (!renewalDate || !appDate || !lastRenewal || !nmcPin || !selectedQualifications) {
        setError("Fill out required fields");
        return;
      }

      const { data, error } = await supabase
        .from('reval_members')
        .update({
          renewal_date: renewalDate,
          reval_application_date: appDate,
          last_renewal_date: lastRenewal,
          nmc_pin: nmcPin
        })
        .eq('id', id)
        .select('id'); // Keep it minimal for now

      if (error) {
        console.error(error);
        setError("There has been an issue");
        return;
      }

      const memberId = data?.[0]?.id;
      if (!memberId) {
        setError("Could not find member ID");
        return;
      }

      // Delete existing qualifications
      await supabase
        .from('reval_member_qualifications')
        .delete()
        .eq('reval_member_id', memberId);

      // Insert selected qualifications
      const inserts = selectedQualifications.map((qualId) => ({
        reval_member_id: memberId,
        qualification_id: qualId,
      }));

      if (inserts.length > 0) {
        const { error: insertError } = await supabase
          .from('reval_member_qualifications')
          .insert(inserts);

        if (insertError) {
          console.error(insertError);
          setError("Failed to update qualifications.");
          return;
        }
      }

      // Refetch updated profile
      const { data: updatedProfile, error: refetchError } = await supabase
        .from('profile')
        .select('*, reval_members(*, reval_member_qualifications(*, reval_qualification(*)))')
        .eq('id', profile.id)
        .single();

      if (refetchError) {
        console.error(refetchError);
        setError("Profile updated, but failed to refresh data.");
        return;
      }

      setProfile(updatedProfile);
      setSuccess("Your information has been updated.");
      setError("");
    };

  useEffect(() => {
    const fetchQualifications = async () => {
    const { data: qualifications } = await supabase
      .from('reval_qualification')
      .select('*');
    setAllQualifications(qualifications || []);
  };

    const fetchMemberQualifications = async () => {
        if (!profile?.reval_members?.id) return;

        const { data: memberQualifications } = await supabase
        .from('reval_member_qualifications')
        .select('qualification_id')
        .eq('reval_member_id', profile.reval_members.id);

        const ids = memberQualifications?.map((q) => q.qualification_id) || [];
        setSelectedQualifications(ids);
    };

    if (!profile) return;
    fetchQualifications();
    fetchMemberQualifications();
    setTier(profile.reval_members.membership_tier);
    setRenewalDate(profile.reval_members.renewal_date);
    setAppDate(profile.reval_members.reval_application_date);
    setLastRenewal(profile.reval_members.last_renewal_date);
    setNmcPin(profile.reval_members.nmc_pin);
    setId(profile.id);
  }, [profile]);

    if (loading) return <FontAwesomeIcon icon={faSpinner} style={{position: "absolute", top: "5rem", left: "50%", transform: "translate(-50%, 0)", fontSize: "40px"}}/>;

    if (!profile) return <div>No profile found.</div>;

    return (
    <div>
      <div className="mob-only">
        <MobileProfile />
      </div>  
      <div className="dashboard-body">
          <h1>REVALIDATION PROFILE</h1>
          <p>Your Revalidation Membership is {tier}</p>
          <p>Here you can view or update your revalidation details.</p>

          <div>
              <form onSubmit={handleSubmit}>
                  <table>
                      <tbody>
                          <tr>
                              <th style={{textAlign:"left", paddingRight:"1rem"}}>Renewal Date</th>
                              <td>
                                  <input type="date" value={renewalDate} onChange={(e) => setRenewalDate(e.target.value)} required></input>
                              </td>
                          </tr>
                          <tr>
                              <th style={{textAlign:"left", paddingRight:"1rem"}}>Application Date</th>
                              <td>
                                  <input type="date" value={appDate} onChange={(e) => setAppDate(e.target.value)} required></input>
                              </td>
                          </tr>
                          <tr>
                              <th style={{textAlign:"left", paddingRight:"1rem"}}>Last Renewal Date</th>
                              <td><input type="date" value={lastRenewal} onChange={(e) => setLastRenewal(e.target.value)} required></input></td>
                          </tr>
                          <tr>
                              <th style={{textAlign:"left", paddingRight:"1rem"}}>NMC Pin</th>
                              <td><input type="text" value={nmcPin} onChange={(e) => setNmcPin(e.target.value)} required></input></td>
                          </tr>
                          <tr className="qualification-checkbox">
                              <th style={{textAlign:"left", verticalAlign: "top"}}>Qualification(s)</th>
                              <td>
                                  {allQualifications.map((q) => (
                                      <label key={q.id}>
                                          <input
                                          type="checkbox"
                                          checked={selectedQualifications.includes(q.id)}
                                          onChange={() => {
                                              if (selectedQualifications.includes(q.id)) {
                                              setSelectedQualifications(selectedQualifications.filter((id) => id !== q.id));
                                              } else {
                                              setSelectedQualifications([...selectedQualifications, q.id]);
                                              }
                                          }}
                                          />
                                          {q.qualification}
                                      </label>
                                      ))}
                              </td>
                          </tr>
                      </tbody>
                  </table>
                  <br></br>
                  <button type="submit">Update</button>
              </form>    
              <br></br>
              {error && <p className="error-message">{error}</p>}
              {success && <p className="success">{success}</p>} 
          </div>

          <div>
            <a href="https://billing.stripe.com/p/login/3cIdRbenwbqT6Fh0zw97G00" target="_blank"><button>Manage Your Subscription</button></a>
          </div>
          <div className="mob-bottom-buffer">
          </div>
      </div>
    </div>
  )
};

export default RevalidationProfile;